/*@ngInject*/
const DefaultPreferencesRepository = function (baseCachedSharedPromiseRepository, preferenceModel) {

    let sharedPromiseCache = {};

    angular.extend(this, baseCachedSharedPromiseRepository);

    this.getCacheName = function () {
        return 'preferenceRepository';
    };

    this.getCacheCapacity = function () {
        return 10;
    };

    this.getSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.processResponseData = function (responseData) {
        let defaultPreferences = _.mapKeys(responseData, function (entry) {
            return entry.name;
        });

        preferenceModel.setDefaultPreferences(defaultPreferences);

        return defaultPreferences;
    };

    this.loadDefaultPreferences = function () {
        let url = '/rest/DefaultPreference',
            cacheKey = 'defaultPref';

        return this.get(cacheKey, url);
    };
};

angular.module('umCore')
    .service('defaultPreferencesRepository', DefaultPreferencesRepository);
